import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ScriptLogForm from '../components/ScriptLogForm'
import {
  fetchDeleteScene,
  fetchDeleteSlate,
  fetchDeleteTake,
  fetchSaveScene,
  fetchSaveSlate,
  fetchSaveTake,
  updateScene,
  updateSlate,
  updateTake
} from '../actions/Script'

const mapStateToProps = ({templates, script}) => ({
  template: templates.byId[templates.activeId],
  script
})

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      updateScene: updateScene,
      saveScene: fetchSaveScene,
      deleteScene: fetchDeleteScene,

      updateSlate: updateSlate,
      saveSlate: fetchSaveSlate,
      deleteSlate: fetchDeleteSlate,

      updateTake: updateTake,
      saveTake: fetchSaveTake,
      deleteTake: fetchDeleteTake
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ScriptLogForm)


// WEBPACK FOOTER //
// ./containers/ScriptLogForm.js